// extracted by mini-css-extract-plugin
export var commonLayoutStyles = "layout-module--commonLayoutStyles--ad64S";
export var skipToContent = "layout-module--skipToContent--0gNb7";